import { ApiMethod } from '@wajeez-web/stores/base';
import { Server, contentClient } from '@wajeez-web/core/api-base';
import { thunkErrorHandler } from '@wajeez-web/core/utils';

export const getContentEntityTypeNavigationsDataTable: ApiMethod<
  Server.ContentEntityTypeNavigationDatatable,
  Server.TableOfContentEntityTypeNavigationColumns,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_ContentEntityTypeNavigations_Client(
        undefined,
        contentClient
      );

      const response =
        await client.admin_ContentEntityTypeNavigations_datatable_post_V1(data);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const getContentEntityTypeNavigationById: ApiMethod<
  number,
  Server.DashboardContentEntityTypeNavigationOutput,
  void
> = async (id, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_ContentEntityTypeNavigations_Client(
        undefined,
        contentClient
      );

      const response =
        await client.admin_ContentEntityTypeNavigations_byId_get_V1(id);

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const createContentEntityTypeNavigation: ApiMethod<
  Server.CreateContentEntityTypeNavigationInput,
  number,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_ContentEntityTypeNavigations_Client(
        undefined,
        contentClient
      );

      const response = await client.admin_ContentEntityTypeNavigations_post_V1(
        data
      );

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};

export const editContentEntityTypeNavigation: ApiMethod<
  Server.UpdateContentEntityTypeNavigationInput,
  number,
  void
> = async (data, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      const client = new Server.Server_ContentEntityTypeNavigations_Client(
        undefined,
        contentClient
      );

      const response = await client.admin_ContentEntityTypeNavigations_put_V1(
        data
      );

      if (response.success && response.data) {
        return response.data;
      }

      return rejectWithValue(response.errors);
    },
    dispatch,
    rejectWithValue
  );
};
